import { styled } from "twin.macro";

export const IconWrapper = styled.span(
  ({
    fillColor = "fill-dark-purple-50",
    opacity = 100,
  }: {
    fillColor: string;
    opacity: number;
  }) => ({
    path: {
      fill: fillColor,
      opacity: opacity,
    },
  })
);
